/**
 * Created by cate on 28-06-17.
 */

import { SteelProfile } from '../steel-profile/steel-profile';
import { Warehouse1ParamsFormComponent } from './project-form-components/warehouse-params-forms/warehouse1-params-form/warehouse1-params-form.component';
import { Warehouse2ParamsFormComponent } from './project-form-components/warehouse-params-forms/warehouse2-params-form/warehouse2-params-form.component';
import { Warehouse3ParamsFormComponent } from './project-form-components/warehouse-params-forms/warehouse3-params-form/warehouse3-params-form.component';
import { Warehouse4ParamsFormComponent } from './project-form-components/warehouse-params-forms/warehouse4-params-form/warehouse4-params-form.component';
import { Warehouse5ParamsFormComponent } from './project-form-components/warehouse-params-forms/warehouse5-params-form/warehouse5-params-form.component';
import { Warehouse6ParamsFormComponent } from './project-form-components/warehouse-params-forms/warehouse6-params-form/warehouse6-params-form.component';
import { Warehouse1ProfilesFormComponent } from 'app/project/project-form-components/warehouse-profiles-form/warehouse1-profiles-form/warehouse1-profiles-form.component';
import { Warehouse2ProfilesFormComponent } from 'app/project/project-form-components/warehouse-profiles-form/warehouse2-profiles-form/warehouse2-profiles-form.component';
import { Warehouse3ProfilesFormComponent } from 'app/project/project-form-components/warehouse-profiles-form/warehouse3-profiles-form/warehouse3-profiles-form.component';
import { Warehouse4ProfilesFormComponent } from 'app/project/project-form-components/warehouse-profiles-form/warehouse4-profiles-form/warehouse4-profiles-form.component';
import { Warehouse5ProfilesFormComponent } from 'app/project/project-form-components/warehouse-profiles-form/warehouse5-profiles-form/warehouse5-profiles-form.component';
import { Warehouse6ProfilesFormComponent } from 'app/project/project-form-components/warehouse-profiles-form/warehouse6-profiles-form/warehouse6-profiles-form.component';

const WindConditions = [
  { name: 'Campo', value: 'campo' },
  { name: 'Ciudad', value: 'ciudad' }
];

const SupportConditions = [
  { name: 'Empotrado', value: 'empotrado' },
  { name: 'Rotulado', value: 'rotulado' }

];

const roofPurlinSupportConditions = [
  { value: 'c', name: 'Continua' },
  { value: 'sa', name: 'Simplemente Apoyada' }
]

const roofPurlinSupportConditionsWithoutC = [
  { value: 'sa', name: 'Simplemente Apoyada' }
]

const roofPurlinCoveringType = [
  { value: 'sr', name: 'Sin Cubierta Rigida' },
  { value: 'cr', name: 'Con Cubierta Rigida' }
]

const rs = [
  { value: 4, name: 'Nave de acero liviana'},
  { value: 5, name: 'Estructura de Marcos dúctiles de acero'}
]

export const WarehouseTypes = [
  { name: 'Caso 1', value: 0, icon: 'assets/images/caso1.png' },
  { name: 'Caso 2', value: 1, icon: 'assets/images/caso2.png' },
  { name: 'Caso 3', value: 2, icon: 'assets/images/caso3.png' },
  { name: 'Caso 4', value: 3, icon: 'assets/images/caso4.png' },
  { name: 'Caso 5', value: 4, icon: 'assets/images/caso5.png' },
  { name: 'Caso 6', value: 5, icon: 'assets/images/caso6.png' }
];

const WarehouseParamsFormComponents = {
  0: Warehouse1ParamsFormComponent,
  1: Warehouse2ParamsFormComponent,
  2: Warehouse3ParamsFormComponent,
  3: Warehouse4ParamsFormComponent,
  4: Warehouse5ParamsFormComponent,
  5: Warehouse6ParamsFormComponent
};

const WarehouseProfilesFormComponents = {
  0: Warehouse1ProfilesFormComponent,
  1: Warehouse2ProfilesFormComponent,
  2: Warehouse3ProfilesFormComponent,
  3: Warehouse4ProfilesFormComponent,
  4: Warehouse5ProfilesFormComponent,
  5: Warehouse6ProfilesFormComponent,
};

export abstract class Warehouse {
  id: number;
  type: number;
  frame_distance: number;
  total_length: number;
  wind_condition: string;
  support_condition_left: string;
  support_condition_right: string;
  covering: number;
  has_lateral_lining: boolean;
  lateral_lining: boolean;
  has_front_lining: boolean;
  front_lining: boolean;
  opening_width: number;
  opening_height: number;
  wind_column_type: number;
  wind_column_profile: number;
  wind_column_max_sep: number;
  cross_bracing_type_left: number;
  cross_bracing_type_right: number;
  cross_bracing_left: number;
  cross_bracing_right: number;
  cross_bracing_max_empty_modules: number;
  eave_struct_type_shoulder: number;
  eave_struct_type_roof: number;
  eave_struct_shoulder: number;
  eave_struct_roof: number;
  front_purlin_type: number;
  front_purlin_profile: number;
  front_purlin_max_sep: number;
  front_purlin_hb_profile: number;
  wall_purlin_type: number;
  wall_purlin_profile: number;
  wall_purlin_max_sep: number;
  wall_purlin_hb_profile: number;
  wall_purlin_hb_max_sep: number;
  roof_purlin_type: number;
  covering_type: string;
  roof_support_condition: string;
  roof_purlin_profile: number;
  roof_purlin_profile_extreme: number;
  roof_purlin_max_sep: number;
  displacement_x: number;
  displacement_y: number;
  has_hb: boolean;
  hb_front_type: number;
  hb_front_profile: number;
  hb_lateral_type: number;
  hb_lateral_profile: number;
  hb_additional_height: number;
  pp: number;
  a: number; // % de masa sísmica aportada por carga viva
  rfactor: number; // Factor de Modificacion de respuesta
  latitude: number;
  altitude: number;
  hbl: number;
  hbr: number;
  sc: number;
  snow: number;
  po: number;
  pb: number;
  uf: number; // Factor de utilizacion
  suggested_profile: string; // Perfil recomendado


  static getWindConditions() {
    return WindConditions;
  }

  static getSupportConditions() {
    return SupportConditions;
  }

  static getRoofPurlinSupportConditions() {
    return roofPurlinSupportConditions;
  }

  static getRoofPurlinSupportConditionsWithoutC() {
    return roofPurlinSupportConditionsWithoutC;
  }

  static getRoofPurlinCoveringType() {
    return roofPurlinCoveringType;
  }

  static getRs() {
    return rs;
  }

  static getWarehouseTypes() {
    return WarehouseTypes;
  }

  static getWarehouseParamsFormComponent(type: number) {
    return WarehouseParamsFormComponents[type];
  }

  static getWarehouseProfilesFormComponent(type: number) {
    return WarehouseProfilesFormComponents[type];
  }

  static getWarehouseByType(type: number) {
    switch (type) {
      case 0: {
        return new Warehouse1();
      }
      case 1: {
        return new Warehouse2();
      }
      case 2: {
        return new Warehouse3();
      }
      case 3: {
        return new Warehouse4();
      }
      case 4: {
        return new Warehouse5();
      }
      case 5: {
        return new Warehouse6();
      }
    }
  }

  constructor() {
    this.id = -1;
    this.type = -1;
    this.frame_distance = null;
    this.total_length = null;
    this.wind_condition = Warehouse.getWindConditions()[0].value;
    this.support_condition_left = Warehouse.getSupportConditions()[0].value;
    this.support_condition_right = Warehouse.getSupportConditions()[0].value;
    this.covering = null;
    this.has_lateral_lining = false;
    this.lateral_lining = null;
    this.has_front_lining = false;
    this.front_lining = null;
    this.opening_height = 0;
    this.opening_width = 0;
    this.has_hb = false;
    this.hb_additional_height = 0;
    this.hb_front_profile = null;
    this.hb_lateral_profile = null;
    this.hb_front_type = -1;
    this.hb_lateral_type = -1;
  }

}

export class Warehouse1
  extends Warehouse {
  profile_1: number;
  profile_2: number;
  profile_3: number;
  profile_4: number;
  slope_1: number;
  slope_2: number;
  column_height: number;
  width_1: number;
  width_2: number;

  static getWarehouseType() {
    return 0;
  }

  constructor() {
    super();
    this.type = Warehouse1.getWarehouseType();
    this.profile_1 = null;
    this.profile_2 = null;
    this.profile_3 = null;
    this.profile_4 = null;
    this.slope_1 = null;
    this.slope_2 = null;
    this.column_height = null;
    this.width_1 = null;
    this.width_2 = null;
  }
}

export class Warehouse2 extends Warehouse {
  profile_1: number;
  profile_2: number;
  profile_3: number;
  profile_4: number;
  profile_5: number;
  profile_6: number;
  profile_7: number;
  slope_1: number;
  slope_2: number;
  column_height: number;
  width_1: number;
  width_2: number;
  support_condition_central: string;

  static getWarehouseType() {
    return 1;
  }

  constructor() {
    super();
    this.type = Warehouse2.getWarehouseType();
    this.profile_1 = null;
    this.profile_2 = null;
    this.profile_3 = null;
    this.profile_4 = null;
    this.profile_5 = null;
    this.profile_6 = null;
    this.profile_7 = null;
    this.slope_1 = null;
    this.slope_2 = null;
    this.column_height = null;
    this.width_1 = null;
    this.width_2 = null;
    this.support_condition_central = Warehouse.getSupportConditions()[0].value;
  }
}

export class Warehouse3 extends Warehouse {
  profile_1: number;
  profile_2: number;
  profile_3: number;
  profile_4: number;
  profile_5: number;
  profile_6: number;
  profile_7: number;
  profile_8: number;
  slope_1: number;
  slope_2: number;
  column_height: number;
  width_1: number;
  width_2: number;
  column_distance: number;
  support_condition_central: string;

  static getWarehouseType() {
    return 2;
  }

  constructor() {
    super();
    this.type = Warehouse3.getWarehouseType();
    this.profile_1 = null;
    this.profile_2 = null;
    this.profile_3 = null;
    this.profile_4 = null;
    this.profile_5 = null;
    this.profile_6 = null;
    this.profile_7 = null;
    this.profile_8 = null;
    this.slope_1 = null;
    this.slope_2 = null;
    this.column_height = null;
    this.width_1 = null;
    this.width_2 = null;
    this.column_distance = null;
    this.support_condition_central = Warehouse.getSupportConditions()[0].value;
  }
}

export class Warehouse4 extends Warehouse {
  profile_1: number;
  profile_2: number;
  profile_3: number;
  profile_4: number;
  slope_1: number;
  column_height: number;
  width_1: number;

  static getWarehouseType() {
    return 3;
  }

  constructor() {
    super();
    this.type = Warehouse4.getWarehouseType();
    this.profile_1 = null;
    this.profile_2 = null;
    this.profile_3 = null;
    this.profile_4 = null;
    this.slope_1 = null;
    this.column_height = null;
    this.width_1 = null;
  }
}

export class Warehouse5 extends Warehouse {
  profile_1: number;
  profile_2: number;
  profile_3: number;
  profile_4: number;
  profile_5: number;
  profile_6: number;
  profile_7: number;
  slope_1: number;
  column_height: number;
  width_1: number;
  column_distance: number;
  support_condition_central: string;

  static getWarehouseType() {
    return 4;
  }

  constructor() {
    super();
    this.type = Warehouse5.getWarehouseType();
    this.profile_1 = null;
    this.profile_2 = null;
    this.profile_3 = null;
    this.profile_4 = null;
    this.profile_5 = null;
    this.profile_6 = null;
    this.profile_7 = null;
    this.slope_1 = null;
    this.column_height = null;
    this.width_1 = null;
    this.column_distance = null;
    this.support_condition_central = Warehouse.getSupportConditions()[0].value;
  }
}

export class Warehouse6 extends Warehouse {
  profile_1: number;
  profile_2: number;
  profile_3: number;
  profile_4: number;
  profile_5: number;
  profile_6: number;
  profile_7: number;
  slope_1: number;
  slope_2: number;
  slope_3: number;
  slope_4: number;
  column_height: number;
  width_1: number;
  width_2: number;
  width_3: number;
  width_4: number;
  support_condition_central: string;

  static getWarehouseType() {
    return 5;
  }

  constructor() {
    super();
    this.type = Warehouse6.getWarehouseType();
    this.profile_1 = null;
    this.profile_2 = null;
    this.profile_3 = null;
    this.profile_4 = null;
    this.profile_5 = null;
    this.profile_6 = null;
    this.profile_7 = null;
    this.slope_1 = null;
    this.slope_2 = null;
    this.slope_3 = null;
    this.slope_4 = null;
    this.column_height = null;
    this.width_1 = null;
    this.width_2 = null;
    this.width_3 = null;
    this.width_4 = null;
    this.support_condition_central = Warehouse.getSupportConditions()[0].value;
  }
}



// WEBPACK FOOTER //
// ./src/app/project/warehouse.ts